import type { FunctionComponent } from 'react';

import { BreakPoints } from '@kanda-libs/ks-design-library';

import Desktop from './Desktop';
import Mobile from './Mobile';

export interface JobLayoutProps {
  children: JSX.Element;
  header?: JSX.Element;
  showSidebar?: boolean;
  showJobCard?: boolean;
  showLines?: boolean;
}

const JobLayout: FunctionComponent<JobLayoutProps> = function (props) {
  return (
    <BreakPoints
      mobile={<Mobile {...props} />}
      desktop={<Desktop {...props} />}
    />
  );
};

export default JobLayout;
